import { useEffect, useState } from 'react';
import { getOwnersByOrgId } from '../../../services/vault/owner';
import { extractErrorMessage } from '../../../util/errorMessage';
import { BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS } from '../../../const';
import { getKycById } from '../../../services/vault/kyc';
import logger from '../../../util/logger';

export default function useOwnersData({
  kyb,
  orgId,
  kybIsFinished,
  orgDataIsFinished,
  primaryKycIsFinished,
}: {
  kyb?: Kyb;
  orgId?: string;
  kybIsFinished: boolean;
  orgDataIsFinished: boolean;
  primaryKycIsFinished: boolean;
}): { owners: Owner[]; isFinished: boolean } {
  const [owners, setOwners] = useState<Owner[]>([]);
  const [isFinished, setIsFinished] = useState(false);
  useEffect(() => {
    if (
      !kybIsFinished ||
      !orgDataIsFinished ||
      // wait for primary kyc to confirm if rep needs to be replaced
      !primaryKycIsFinished ||
      isFinished
    ) {
      return;
    }
    if (orgDataIsFinished && !orgId) {
      setIsFinished(true);
      return;
    }
    const gatherData = async () => {
      if (!orgId) {
        return;
      }

      if (
        kyb &&
        !BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS.includes(kyb.structure)
      ) {
        setIsFinished(true);
        return;
      }

      try {
        const retrievedOwners = await getOwnersByOrgId(orgId);
        for (const owner of retrievedOwners) {
          const kyc = await getKycById(owner.kycId);
          owner.kyc = kyc;
        }
        setOwners(retrievedOwners);
      } catch (e) {
        logger(`Couldn't get owners. ${extractErrorMessage(e)}`);
      } finally {
        setIsFinished(true);
      }
    };
    gatherData();
  }, [
    kyb,
    kybIsFinished,
    orgDataIsFinished,
    orgId,
    isFinished,
    primaryKycIsFinished,
  ]);
  return { owners, isFinished };
}
